var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-container",style:(_vm.padding)},[_c('img',{staticClass:"icon wow fadeInUp",attrs:{"src":"https://img.jozobio.com/img/common/common_header_icon.png"}}),_c('h2',{staticClass:"title-cn wow fadeInUp"},[_vm._v(_vm._s(_vm.cn))]),_c('h2',{staticClass:"title-en wow fadeInUp"},[_vm._v(_vm._s(_vm.en))])])
}
var staticRenderFns = []

export { render, staticRenderFns }